import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Page } from '../../Page';
import { setEventTitle } from '../currentPartyEvent/currentPartyEventSlice';
import { selectCurrentPartyEventTitle, selectCurrentPartyEvent } from '../currentPartyEvent/currentPartyEventSlice';
import styles from './Wizard.module.css'
import { useEffect } from 'react';
import { resetButtons, setBackButtonVisible, setHomeButtonVisible } from '../menu/menuSlice';
import { useNavigate } from 'react-router-dom';
import { BackButton } from '../menu/BackButton';


export function CreateName() {
    const eventTitle = useAppSelector(selectCurrentPartyEventTitle)
    const currentPartyEvent = useAppSelector(selectCurrentPartyEvent)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setHomeButtonVisible(true))
    })
    return (
        <Page>
            <div className={styles.bannerContainer}>
                <div>
                    <h2>PartyPlanner.</h2>
                        <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.bannerButton}>
                    <BackButton/>
                </div>
            </div>
            <div className={styles.header}>
            <h1>PartyPlanner</h1>
            <br></br>
            <h2> OK, let's get started! What's the occasion?</h2>
            <p>(Create a suitable name for the event)</p>
            </div>
            <label className={styles.label} htmlFor='txtEventTitleWizard'>Title:</label>
            <br></br>
            <input
                placeholder='Type name here'
                id='txtEventTitleWizard'
                className={styles.textbox}
                aria-label="Set Event Title"
                value={eventTitle}
                onChange={(e) => {
                   dispatch(setEventTitle(e.target.value))
                }}
                    />
                    <br></br>
            <button className={styles.nextButton}  onClick={() => {
                                        if (currentPartyEvent != null) {
                                            if (!currentPartyEvent.title) {
                                                alert('Please give your party a name, this is required')
                                                return
                                            }
                navigate('/CreateDate')
            }}}>Next</button>
                </Page>
    )
}
